import {
  CustomInput,
  CustomSelect,
  CustomToggle,
  CustomTextarea,
  CustomSlider,
  CustomRadioGroup,
} from './CustomFormElements';
import ColorPickerInput from '../Components/ColorPickerInput';
import { channelTypes } from '../constants/channelTypes';
import ImageUploader from './ImageUploader';

import Button from './Buttons';
import WorkScheduler from './WorkScheduler';

const TextBlock = ({ title, description, name, value, onChange, isDisabled, height }) => (
  <div className="input-block d-flex flex-row justify-between">
    <div className="input-description">
      <div className="input-title">{title}</div>
      <div className="small-font">{description}</div>
    </div>

    <div className="align-wrapper d-flex align-center">
      <CustomTextarea
        id={name}
        name={name}
        type="text"
        addedText={value}
        onChange={onChange}
        resizable={false}
        disabled={isDisabled}
        height={height}
      />
    </div>
  </div>
);

function ChannelSettings({
  name,
  setName,
  setPhone,
  isPhoneField,
  phoneMandatory,
  setPhoneMandatory,
  agent,
  setAgent,
  language,
  setLanguage,
  channelType,
  setChannelType,
  onSiteOrigin,
  setOnSiteOrigin,
  greetingMessage,
  setGreetingMessage,
  isModerated,
  setIsModerated,
  isAudioAllowed,
  setIsAudioAllowed,
  isImageAllowed,
  setIsImageAllowed,
  isNameRequired,
  setIsNameRequired,
  isFolded,
  setIsFolded,
  isActive,
  setIsActive,
  chatPrimaryColor,
  chatSecondaryColor,
  setChatPrimaryColor,
  setChatSecondaryColor,
  responseDelay,
  setResponseDelay,
  agents,
  isDisabled,
  isNew,
  secrets,
  setSecrets,
  zendeskType,
  setZendeskType,
  zendeskPostType,
  setZendeskPostType,
  zendeskCommentType,
  setZendeskCommentType,
  zendeskDomain,
  setZendeskDomain,
  zendeskAiSubType,
  setZendeskAiSubType,
  zendeskAssistantFieldName,
  setZendeskAssistantFieldName,
  zendeskThemeFieldName,
  setZendeskThemeFieldName,

  helpdeskeUrl,
  setHelpdeskeUrl,

  isFileAllowed,
  setIsFileAllowed,
  anonymizeEntities,
  setAnonymizeEntities,
  embedUrl,
  isConnected,
  metaUsername,
  disconnect,

  // First screen settings
  isFirstScreenEnabled,
  setIsFirstScreenEnabled,
  firstLineText,
  setFirstLineText,
  secondLineText,
  setSecondLineText,
  askBoxFirstLine,
  setAskBoxFirstLine,
  askBoxSecondLine,
  setAskBoxSecondLine,
  askBoxThirdLine,
  setAskBoxThirdLine,
  inputPlaceholderText,
  setInputPlaceholderText,
  chatType,
  setChatType,

  //
  AIassistantImage,
  setAIassistantImage,
  liveAssistantImage,
  setLiveAssistantImage,
  liveAssistantIcon,
  setLiveAssistantIcon,

  isAiAssistant,
  setIsAiAssistant,
  firstMessageDelay,
  setFirstMessageDelay,
  launchSignup,

  textFields,
  setTextFields,

  useContextThematics,
  setUseContextThematics,

  setUseContextMessageTime,
  useContextMessageTime,

  allowedReactions,
  setAllowedReactions,
  isScheduleEnabled,
  setIsScheduleEnabled,
  schedule,
  setSchedule,
  outsideWorkingHours,
  setOutsideWorkingHours,

  smtpAddress,
  setSmtpAddress,
  smtpPort,
  setSmtpPort,
  imapAddress,
  setImapAddress,
  imapPort,
  setImapPort,

  email,
  setEmail,
  emailSignature,
  setEmailSignature,
}) {
  return (
    <div className="int-col-3 p-2 border-yes radius-yes full-width-on-sml-scr">
      <h4 className="h4-title">Main Settings</h4>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Channel name</div>
          <div className="small-font">Enter channel name</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomInput
            id="chat-name"
            label="Channel Name"
            placeholder="Enter channel name"
            type="text"
            icon={<i className="fa-solid fa-comments"></i>}
            value={name}
            onChange={(id, value) => setName(value)}
            disabled={isDisabled}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Agent</div>
          <div className="small-font">Select an agent</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomSelect
            id="agent-select"
            label="Agent"
            options={agents.map((a) => ({
              value: a.key,
              label: a.name,
            }))}
            value={agent}
            multiSelect={false}
            onChange={(val) => setAgent(val)}
            disabled={isDisabled}
          />
        </div>
      </div>

      {channelType !== 'EMAIL' && (
        <>
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Response Delay</div>
              <div className="small-font">Set response delay (0-60)</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomSlider
                id="temperature-slider"
                label="Response Delay"
                min={0}
                max={60}
                oneStep={1}
                suffix=" seconds"
                value={responseDelay}
                onChange={(val) => setResponseDelay(val)}
                disabled={isDisabled}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">First Message Delay</div>
              <div className="small-font">Set first message delay (0-60)</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomSlider
                id="temperature-slider"
                label="First Message Delay"
                min={0}
                max={60}
                oneStep={1}
                suffix=" seconds"
                value={firstMessageDelay}
                onChange={(val) => setFirstMessageDelay(val)}
                disabled={isDisabled}
              />
            </div>
          </div>
        </>
      )}

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Use Context Thematics</div>
          <div className="small-font">Enable or disable context thematics usage</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomToggle
            id="use-context-thematics"
            label={useContextThematics ? 'Enabled' : 'Disabled'}
            checked={useContextThematics}
            onChange={(id, value) => setUseContextThematics(value)}
            disabled={isDisabled}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Use Context Message Time</div>
          <div className="small-font">Pass message creation timestamp to the AI agent</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomToggle
            id="send-message-created-time"
            label={useContextMessageTime ? 'Enabled' : 'Disabled'}
            checked={useContextMessageTime}
            onChange={(id, value) => setUseContextMessageTime(value)}
            disabled={isDisabled}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Chat interface language</div>
          <div className="small-font">Select chat interface language</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomSelect
            id="chat-interface"
            label="Interface language"
            options={[
              { value: 'ukrainian', label: 'Ukrainian' },
              { value: 'english', label: 'English' },
            ]}
            value={language}
            onChange={(val) => setLanguage(val)}
            multiSelect={false}
            disabled={isDisabled}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Chat channel</div>
          <div className="small-font">Select the source where customers will write from</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomSelect
            id="chat-channel"
            label="Chat channel"
            options={Object.entries(channelTypes).map(([value, label]) => ({
              value,
              label,
            }))}
            onChange={(value) => setChannelType(value)}
            value={channelType}
            multiSelect={false}
            disabled={isDisabled || isNew === false}
          />
        </div>
      </div>

      {channelType === 'TELEGRAM' && (
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Telegram token</div>
            <div className="small-font">Enter Telegram token</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <CustomInput
              id="telegram-token"
              label="Telegram token"
              placeholder="Enter token"
              icon={<i className="fa-brands fa-telegram"></i>}
              value={secrets?.telegram_token}
              onChange={(id, value) => setSecrets({ telegram_token: value })}
              disabled={isDisabled}
              type="text"
            />
          </div>
        </div>
      )}

      {channelType === 'ZENDESK' && (
        <>
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Zendesk Domain</div>
              <div className="small-font">Enter Zendesk Domain</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="zendesk-domain"
                label="Zendesk Domain"
                placeholder="Enter domain"
                icon={<i className="fa-brands fa-telegram"></i>}
                value={zendeskDomain}
                onChange={(id, value) => setZendeskDomain(value)}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Zendesk Type</div>
              <div className="small-font">Enter Zendesk Type</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomSelect
                id="zendesk-type"
                label="Zendesk Type"
                options={[
                  { value: 'TICKET', label: 'Ticket' },
                  { value: 'TRIGGER', label: 'Trigger' },
                ]}
                onChange={(value) => setZendeskType(value)}
                value={zendeskType}
                multiSelect={false}
                disabled={isDisabled || isNew === false}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Zendesk Post Type</div>
              <div className="small-font">Enter Zendesk Post Type</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomSelect
                id="zendesk-post-type"
                label="Zendesk Post Type"
                options={[
                  { value: 'CONVERSATION', label: 'Conversation' },
                  { value: 'COMMENT', label: 'Comment' },
                ]}
                onChange={(value) => setZendeskPostType(value)}
                value={zendeskPostType}
                multiSelect={false}
                disabled={isDisabled}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Zendesk Ticket Status Field Name</div>
              <div className="small-font">Enter Zendesk Ticket Status Field Name</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="zendesk-ticket-status-field-name"
                label="Zendesk Ticket Status Field Name"
                placeholder="Enter Zendesk Ticket Status Field Name"
                icon={<i className="fa-brands fa-telegram"></i>}
                value={zendeskAssistantFieldName}
                onChange={(id, value) => setZendeskAssistantFieldName(value)}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Zendesk Ticket Thematic Field Name</div>
              <div className="small-font">Enter Zendesk Ticket Thematic Field Name</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="zendesk-ticket-thematic-field-name"
                label="Zendesk Ticket Thematic Field Name"
                placeholder="Enter Zendesk Ticket Thematic Field Name"
                icon={<i className="fa-brands fa-telegram"></i>}
                value={zendeskThemeFieldName}
                onChange={(id, value) => setZendeskThemeFieldName(value)}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Zendesk Ticket Email Key</div>
              <div className="small-font">Enter Zendesk Ticket Email Key</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="zendesk-ticket-email-key"
                label="Zendesk Ticket Email Key"
                placeholder="Enter token"
                icon={<i className="fa-brands fa-telegram"></i>}
                value={secrets?.zendesk_ticket_key_email}
                onChange={(id, value) => setSecrets({ zendesk_ticket_key_email: value })}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Zendesk Ticket Key</div>
              <div className="small-font">Enter Zendesk Ticket Key</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="zendesk-ticket-key"
                label="Zendesk Ticket Key"
                placeholder="Enter token"
                icon={<i className="fa-brands fa-telegram"></i>}
                value={secrets?.zendesk_ticket_key}
                onChange={(id, value) => setSecrets({ zendesk_ticket_key: value })}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          {zendeskType === 'TICKET' && (
            <>
              <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                  <div className="input-title">Zendesk Ticket Webhook Secret</div>
                  <div className="small-font">Enter Zendesk Ticket Webhook Secret</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <CustomInput
                    id="zendesk-ticket-webhook-secret"
                    label="Zendesk Ticket Webhook Secret"
                    placeholder="Enter token"
                    icon={<i className="fa-brands fa-telegram"></i>}
                    value={secrets?.zendesk_ticket_webhook_secret}
                    onChange={(id, value) => setSecrets({ zendesk_ticket_webhook_secret: value })}
                    disabled={isDisabled}
                    type="text"
                  />
                </div>
              </div>
            </>
          )}

          {zendeskType === 'CONVERSATION' && (
            <>
              <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                  <div className="input-title">Zendesk Conversation Webhook Secret</div>
                  <div className="small-font">Enter Zendesk Conversation Webhook Secret</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <CustomInput
                    id="zendesk-conversation-webhook-secret"
                    label="Zendesk Conversation Webhook Secret"
                    placeholder="Enter token"
                    icon={<i className="fa-brands fa-telegram"></i>}
                    value={secrets?.zendesk_conversation_webhook_secret}
                    onChange={(id, value) =>
                      setSecrets({ zendesk_conversation_webhook_secret: value })
                    }
                    disabled={isDisabled}
                    type="text"
                  />
                </div>
              </div>
            </>
          )}

          {zendeskType === 'TRIGGER' && (
            <>
              <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                  <div className="input-title">Zendesk Trigger Webhook Secret</div>
                  <div className="small-font">Enter Zendesk Trigger Webhook Secret</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <CustomInput
                    id="zendesk-trigger-webhook-secret"
                    label="Zendesk Trigger Webhook Secret"
                    placeholder="Enter token"
                    icon={<i className="fa-brands fa-telegram"></i>}
                    value={secrets?.zendesk_trigger_webhook_secret}
                    onChange={(id, value) => setSecrets({ zendesk_trigger_webhook_secret: value })}
                    disabled={isDisabled}
                    type="text"
                  />
                </div>
              </div>
            </>
          )}

          {zendeskPostType === 'COMMENT' && (
            <>
              <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                  <div className="input-title">Zendesk Comment Type</div>
                  <div className="small-font">Enter Zendesk Comment Type</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <CustomSelect
                    id="zendesk-comment-type"
                    label="Zendesk Comment Type"
                    options={[
                      { value: 'PRIVATE', label: 'Private' },
                      { value: 'PUBLIC', label: 'Public' },
                    ]}
                    onChange={(value) => setZendeskCommentType(value)}
                    value={zendeskCommentType}
                    multiSelect={false}
                    disabled={isDisabled}
                  />
                </div>
              </div>
            </>
          )}

          {zendeskPostType === 'CONVERSATION' && (
            <>
              <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                  <div className="input-title">Mark Message as AI Generated</div>
                  <div className="small-font">
                    Enable or disable marking messages as AI generated
                  </div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <CustomToggle
                    id="audio-upload"
                    label={zendeskAiSubType ? 'Enabled' : 'Disabled'}
                    checked={zendeskAiSubType}
                    onChange={(id, value) => setZendeskAiSubType(value)}
                    disabled={isDisabled}
                  />
                </div>
              </div>

              <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                  <div className="input-title">Zendesk Conversation App Id</div>
                  <div className="small-font">Enter Zendesk Conversation App Id</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <CustomInput
                    id="zendesk-conversation-app-id"
                    label="Zendesk Conversation App Id"
                    placeholder="Enter token"
                    icon={<i className="fa-brands fa-telegram"></i>}
                    value={secrets?.zendesk_conversation_app_id}
                    onChange={(id, value) => setSecrets({ zendesk_conversation_app_id: value })}
                    disabled={isDisabled}
                    type="text"
                  />
                </div>
              </div>

              <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                  <div className="input-title">Zendesk Conversation Key</div>
                  <div className="small-font">Enter Zendesk Conversation Key</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <CustomInput
                    id="zendesk-conversation-key"
                    label="Zendesk Conversation Key"
                    placeholder="Enter token"
                    icon={<i className="fa-brands fa-telegram"></i>}
                    value={secrets?.zendesk_conversation_key}
                    onChange={(id, value) => setSecrets({ zendesk_conversation_key: value })}
                    disabled={isDisabled}
                    type="text"
                  />
                </div>
              </div>

              <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                  <div className="input-title">Zendesk Conversation Key Secret</div>
                  <div className="small-font">Enter Zendesk Conversation Key Secret</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <CustomInput
                    id="zendesk-conversation-key"
                    label="Zendesk Conversation Key Secret"
                    placeholder="Enter token"
                    icon={<i className="fa-brands fa-telegram"></i>}
                    value={secrets?.zendesk_conversation_key_secret}
                    onChange={(id, value) => setSecrets({ zendesk_conversation_key_secret: value })}
                    disabled={isDisabled}
                    type="text"
                  />
                </div>
              </div>
            </>
          )}
        </>
      )}

      {channelType === 'IFRAME' && (
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Original site</div>
            <div className="small-font">Enter the original site</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <CustomInput
              id="original-site"
              label="Original site"
              placeholder="Enter site"
              icon={<i className="fa-solid fa-globe"></i>}
              value={onSiteOrigin}
              onChange={(id, value) => setOnSiteOrigin(value)}
              disabled={isDisabled}
              type="text"
            />
          </div>
        </div>
      )}

      {channelType === 'HELPDESKE' && (
        <>
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Helpdeske URL</div>
              <div className="small-font">Enter URL</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="helpdeske-url"
                label="Helpdeske URL"
                placeholder="Enter URL"
                icon={<i className="fa-solid fa-globe"></i>}
                value={helpdeskeUrl}
                onChange={(id, value) => setHelpdeskeUrl(value)}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Helpdeske Login</div>
              <div className="small-font">Enter login</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="helpdeske-login"
                label="Helpdeske Login"
                placeholder="Enter login"
                icon={<i className="fa-solid fa-user"></i>}
                value={secrets?.helpdeske_login}
                onChange={(id, value) => setSecrets({ helpdeske_login: value })}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Helpdeske Password</div>
              <div className="small-font">Enter password</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="helpdeske-password"
                label="Helpdeske Password"
                placeholder="Enter password"
                icon={<i className="fa-solid fa-lock"></i>}
                value={secrets?.helpdeske_password}
                onChange={(id, value) => setSecrets({ helpdeske_password: value })}
                disabled={isDisabled}
                type="password"
              />
            </div>
          </div>
        </>
      )}

      {channelType === 'INTERCOM' && (
        <>
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Intercom Access Token</div>
              <div className="small-font">Enter Intercom Access Token</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="intercom-access-token"
                label="Intercom Access Token"
                placeholder="Enter access token"
                icon={<i className="fa-solid fa-key"></i>}
                value={secrets?.intercom_access_token}
                onChange={(id, value) => setSecrets({ intercom_access_token: value })}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Intercom Client ID</div>
              <div className="small-font">Enter Intercom Client ID</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="intercom-client-id"
                label="Intercom Client ID"
                placeholder="Enter client ID"
                icon={<i className="fa-solid fa-id-card"></i>}
                value={secrets?.intercom_client_id}
                onChange={(id, value) => setSecrets({ intercom_client_id: value })}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Intercom Client Secret</div>
              <div className="small-font">Enter Intercom Client Secret</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="intercom-client-secret"
                label="Intercom Client Secret"
                placeholder="Enter client secret"
                icon={<i className="fa-solid fa-lock"></i>}
                value={secrets?.intercom_client_secret}
                onChange={(id, value) => setSecrets({ intercom_client_secret: value })}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>
        </>
      )}

      {channelType === 'EMAIL' && (
        <>
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">SMTP Address</div>
              <div className="small-font">Enter SMTP Address</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="smtp-address"
                label="SMTP Address"
                placeholder="Enter SMTP Address"
                icon={<i className="fa-solid fa-paper-plane"></i>}
                value={smtpAddress}
                onChange={(id, value) => setSmtpAddress(value)}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">SMTP Port</div>
              <div className="small-font">Enter SMTP Port</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="smtp-port"
                label="SMTP Port"
                placeholder="Enter SMTP Port"
                icon={<i className="fa-solid fa-hashtag"></i>}
                value={smtpPort}
                onChange={(id, value) => setSmtpPort(value)}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">IMAP Address</div>
              <div className="small-font">Enter IMAP Address</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="imap-address"
                label="IMAP Address"
                placeholder="Enter IMAP Address"
                icon={<i className="fa-solid fa-inbox"></i>}
                value={imapAddress}
                onChange={(id, value) => setImapAddress(value)}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">IMAP Port</div>
              <div className="small-font">Enter IMAP Port</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="imap-port"
                label="IMAP Port"
                placeholder="Enter IMAP Port"
                icon={<i className="fa-solid fa-hashtag"></i>}
                value={imapPort}
                onChange={(id, value) => setImapPort(value)}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Email</div>
              <div className="small-font">Enter email address</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="email"
                label="Email"
                placeholder="Enter email address"
                icon={<i className="fa-solid fa-envelope"></i>}
                value={email}
                onChange={(id, value) => setEmail(value)}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Password</div>
              <div className="small-font">Enter email password</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="email-password"
                label="Password"
                placeholder="Enter password"
                icon={<i className="fa-solid fa-lock"></i>}
                value={secrets?.email_password}
                onChange={(id, value) => setSecrets({ email_password: value })}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Email Signature</div>
              <div className="small-font">Enter email signature</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomTextarea
                id="signature"
                label="Signature"
                mandatory={false}
                disabled={false}
                resizable={false}
                addedText={emailSignature}
                height="200px"
                onChange={(value) => setEmailSignature(value)}
              />
            </div>
          </div>
        </>
      )}
      {channelType !== 'EMAIL' && (
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Greeting message</div>
            <div className="small-font">Add greeting message for the chat</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <CustomTextarea
              id="greeting"
              label="Greeting message"
              name="greeting"
              type="text"
              addedText={greetingMessage}
              onChange={(value) => setGreetingMessage(value)}
              resizable={false}
              disabled={isDisabled}
              height="200px"
            />
          </div>
        </div>
      )}

      {channelType === 'WHATSAPP' &&
        isNew === false &&
        (!isConnected ? (
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Authorization window</div>
              <div className="small-font">Log in with Facebook to connect your account</div>
            </div>
            <div className="button-container d-flex justify-end">
              <Button variant="primary" size="large" onClick={launchSignup}>
                <i className="fa-brands fa-whatsapp" style={{ marginRight: '8px' }}></i>
                Connect Whats App
              </Button>
            </div>
          </div>
        ) : (
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-title" style={{ display: 'flex', alignItems: 'center' }}>
              {metaUsername && (
                <div className="input-title" style={{ display: 'flex', alignItems: 'center' }}>
                  <i
                    className="fa-solid fa-user"
                    style={{ marginRight: '1.5vw', fontSize: '20px' }}
                  ></i>
                  <div>{metaUsername}</div>
                </div>
              )}
            </div>

            <div className="button-container d-flex justify-end">
              <Button variant="danger" size="large" onClick={disconnect}>
                <i className="fa-brands fa-whatsapp" style={{ marginRight: '0.55vw' }}></i>
                Disconnect Whats App
              </Button>
            </div>
          </div>
        ))}

      {channelType === 'INSTAGRAM' &&
        isNew === false &&
        (!isConnected ? (
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Authorization window</div>
              <div className="small-font">Log in with Instagram to connect your account</div>
            </div>
            <div className="button-container d-flex justify-end">
              <Button
                variant="primary"
                size="large"
                onClick={() => (window.location.href = embedUrl)}
              >
                <i className="fa-brands fa-instagram" style={{ marginRight: '8px' }}></i>
                Connect Instagram
              </Button>
            </div>
          </div>
        ) : (
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-title" style={{ display: 'flex', alignItems: 'center' }}>
              {metaUsername && (
                <div className="input-title" style={{ display: 'flex', alignItems: 'center' }}>
                  <i
                    className="fa-solid fa-user"
                    style={{ marginRight: '1.5vw', fontSize: '20px' }}
                  ></i>
                  <div>{metaUsername}</div>
                </div>
              )}
            </div>

            <div className="button-container d-flex justify-end">
              <Button variant="danger" size="large" onClick={disconnect}>
                <i className="fa-brands fa-instagram" style={{ marginRight: '0.55vw' }}></i>
                Disconnect Instagram
              </Button>
            </div>
          </div>
        ))}

      {channelType === 'IFRAME' && (
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Chat Main Color</div>
            <div className="small-font">Adjust the look and feel of the chat</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <ColorPickerInput
              defaultColor={chatPrimaryColor || '#4f46e5ff'}
              value={chatPrimaryColor}
              onChange={setChatPrimaryColor}
            />
          </div>
        </div>
      )}

      {channelType === 'IFRAME' && (
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Chat Secondary Color</div>
            <div className="small-font">Adjust the look and feel of the chat</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <ColorPickerInput
              defaultColor={chatSecondaryColor || '#f9ce69ff'}
              value={chatSecondaryColor}
              onChange={setChatSecondaryColor}
            />
          </div>
        </div>
      )}

      {channelType === 'IFRAME' && (
        <>
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Chat AI Icon</div>
              <div className="small-font">
                Upload the icon for the AI assistant. If not uploaded default icon is used
              </div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <ImageUploader
                id={`ai-assistant-icon`}
                className={`ai-assistant-image`}
                imageWidth="100px"
                imageHeight="100px"
                imageShape="round"
                maxImageSizeMB={1}
                allowedFormats={['image/jpeg', 'image/png']}
                preuploadedImage={AIassistantImage}
                onImageChange={setAIassistantImage}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Live Assistant image</div>
              <div className="small-font">Upload the image for the Live assistant</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <ImageUploader
                id={`ai-assistant-image`}
                className={`ai-assistant-image`}
                imageWidth="100px"
                imageHeight="100px"
                imageShape="round"
                maxImageSizeMB={1}
                allowedFormats={['image/jpeg', 'image/png']}
                preuploadedImage={liveAssistantImage}
                onImageChange={setLiveAssistantImage}
              />
            </div>
          </div>

          {/* <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Live Assistant icon</div>
            <div className="small-font">Select the icon for the Live assistant.
              If image is not uploaded the icon will be used</div>
          </div>
          <div className="align-wrapper d-flex align-center">
             <IconSelector
                selectedIcon={liveAssistantIcon}
                onIconChange={setLiveAssistantIcon}
              />
          </div>
        </div> */}
        </>
      )}
      {['IFRAME', 'TELEGRAM'].includes(channelType) && (
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Allowed reactions</div>
            <div className="small-font">
              Select which reactions are available. If empty (0) reactions will be disabled.
            </div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <CustomSelect
              id="allowed-reactions-select"
              label="Allowed reactions"
              options={[
                { value: 'like', label: '👍 Like' },
                { value: 'heart', label: '❤️ Heart' },
              ]}
              value={allowedReactions}
              multiSelect={true}
              onChange={(val) => setAllowedReactions(val)}
              disabled={isDisabled}
            />
          </div>
        </div>
      )}

      {channelType === 'SENDPULSE' && (
        <>
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Sendpulse API key</div>
              <div className="small-font">Enter sendpulse api key</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="sendpulse-api-key"
                label="Sendpulse api key"
                placeholder="Enter api key"
                icon={<i className="fa-brands fa-telegram"></i>}
                value={secrets?.sendpulse_api_key}
                onChange={(id, value) => setSecrets({ sendpulse_api_key: value })}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Sendpulse Webhook secret</div>
              <div className="small-font">Enter sendpulse webhook secret</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="sendpulse-webhook-secret"
                label="Sendpulse webhook secret"
                placeholder="Enter webhook secret"
                icon={<i className="fa-brands fa-telegram"></i>}
                value={secrets?.sendpulse_webhook_secret}
                onChange={(id, value) => setSecrets({ sendpulse_webhook_secret: value })}
                disabled={isDisabled}
                type="text"
              />
            </div>
          </div>
        </>
      )}

      {/* --------------- FIRST SCREEN SETTINGS ----------------- */}

      {channelType === 'IFRAME' && (
        <>
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Allow first screen</div>
              <div className="small-font">Enable or disable chat first screen</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomToggle
                id="first-screen"
                label={isFirstScreenEnabled ? 'Enabled' : 'Disabled'}
                checked={isFirstScreenEnabled}
                onChange={(id, value) => setIsFirstScreenEnabled(value)}
                disabled={isDisabled}
              />
            </div>
          </div>

          {/* Hide all the text inputs below when first screen is OFF */}

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">First Line Text</div>
              <div className="small-font">Write the initial chat greeting message</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="first-line-text"
                label="First Line Text"
                placeholder="Hello!"
                type="text"
                icon={<i className="fa-solid fa-comments"></i>}
                value={firstLineText}
                onChange={(id, value) => setFirstLineText(value)}
                disabled={isDisabled}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Second Line Text</div>
              <div className="small-font">Write the initial chat greeting message</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="second-line-text"
                label="Second Line Text"
                placeholder="How can I help you today?"
                type="text"
                icon={<i className="fa-solid fa-comments"></i>}
                value={secondLineText}
                onChange={(id, value) => setSecondLineText(value)}
                disabled={isDisabled}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Ask-box First Line</div>
              <div className="small-font">Write Ask box message</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="ask-box-first-line"
                label="Ask-box First Line"
                placeholder="Type your question…"
                type="text"
                icon={<i className="fa-solid fa-comments"></i>}
                value={askBoxFirstLine}
                onChange={(id, value) => setAskBoxFirstLine(value)}
                disabled={isDisabled}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Ask-box Second Line</div>
              <div className="small-font">Write Ask box message</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="ask-box-second-line"
                label="Ask-box Second Line"
                placeholder=""
                type="text"
                icon={<i className="fa-solid fa-comments"></i>}
                value={askBoxSecondLine}
                onChange={(id, value) => setAskBoxSecondLine(value)}
                disabled={isDisabled}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Ask-box Third Line</div>
              <div className="small-font">Write Ask box message</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="ask-box-third-line"
                label="Ask-box Third Line"
                placeholder="You can attach images and files."
                type="text"
                icon={<i className="fa-solid fa-comments"></i>}
                value={askBoxThirdLine}
                onChange={(id, value) => setAskBoxThirdLine(value)}
                disabled={isDisabled}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Input Placeholder Text</div>
              <div className="small-font">Enter placeholder text</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomInput
                id="input-placeholder-text"
                label="Placeholder Text"
                placeholder="Enter placeholder text"
                type="text"
                icon={<i className="fa-solid fa-comments"></i>}
                value={inputPlaceholderText}
                onChange={(id, value) => setInputPlaceholderText(value)}
                disabled={isDisabled}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Chat type</div>
              <div className="small-font">Select chat type — small widget or big static box</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomRadioGroup
                name="chatType"
                options={[
                  { id: 'widget', label: 'Widget', value: 'widget' },
                  { id: 'static-box', label: 'Static box', value: 'static-box' },
                ]}
                // keep value controlled so it always reflects state
                value={chatType}
                defaultValue={chatType || 'widget'}
                onChange={(val) => setChatType(val)}
                disabled={isDisabled}
              />
            </div>
          </div>
        </>
      )}

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Anonymization</div>
          <div className="small-font">Select entity to anonymize (optional)</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomSelect
            id="anonymization-select"
            label="Anonymization"
            options={[
              { value: 'EMAIL_ADDRESS', label: 'Email address' },
              { value: 'PHONE_NUMBER', label: 'Phone number' },
              { value: 'CREDIT_CARD', label: 'Credit card number' },
              { value: 'IBAN', label: 'IBAN' },
              { value: 'URL', label: 'URL' },
              { value: 'PERSON', label: 'Person' },
              { value: 'LOCATION', label: 'Location' },
            ]}
            value={anonymizeEntities}
            multiSelect={true}
            onChange={(val) => setAnonymizeEntities(val)}
            disabled={isDisabled}
          />
        </div>
      </div>

      {/* --------------- END OF FIRST SCREEN SETTINGS ----------------- */}

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Moderate</div>
          <div className="small-font">Enable or disable message moderation</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomToggle
            id="moderated"
            label={isModerated ? 'Enabled' : 'Disabled'}
            checked={isModerated}
            onChange={(id, value) => setIsModerated(value)}
            disabled={isDisabled}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">AI Assistant</div>
          <div className="small-font">Enable or disable AI assistant</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomToggle
            id="Ai_Assistant"
            label={isAiAssistant ? 'Enabled' : 'Disabled'}
            checked={isAiAssistant}
            onChange={(id, value) => setIsAiAssistant(value)}
            disabled={isDisabled}
          />
        </div>
      </div>

      {channelType !== 'ZENDESK' && (
        <>
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Allow audio message upload</div>
              <div className="small-font">Enable or disable audio message upload</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomToggle
                id="audio-upload"
                label={isAudioAllowed ? 'Enabled' : 'Disabled'}
                checked={isAudioAllowed}
                onChange={(id, value) => setIsAudioAllowed(value)}
                disabled={isDisabled}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Allow image message upload</div>
              <div className="small-font">Enable or disable image message upload</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomToggle
                id="image-upload"
                label={isImageAllowed ? 'Enabled' : 'Disabled'}
                checked={isImageAllowed}
                onChange={(id, value) => setIsImageAllowed(value)}
                disabled={isDisabled}
              />
            </div>
          </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Allow file message upload</div>
              <div className="small-font">Enable or disable file message upload</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomToggle
                id="audio-upload"
                label={isFileAllowed ? 'Enabled' : 'Disabled'}
                checked={isFileAllowed}
                onChange={(id, value) => setIsFileAllowed(value)}
                disabled={isDisabled}
              />
            </div>
          </div>
        </>
      )}

      {channelType === 'IFRAME' && (
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Allow Name field</div>
            <div className="small-font">Enable or disable Name requesting (mandaroty field)</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <CustomToggle
              id="request-name"
              label={isNameRequired ? 'Enabled' : 'Disabled'}
              checked={isNameRequired}
              onChange={(id, value) => setIsNameRequired(value)}
              disabled={isDisabled}
            />
          </div>
        </div>
      )}

      {['IFRAME', 'TELEGRAM'].includes(channelType) && (
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Allow Phone field</div>
            <div className="small-font">Enable or disable Phone requesting</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <CustomToggle
              id="request-phone"
              label={isPhoneField ? 'Enabled' : 'Disabled'}
              checked={isPhoneField}
              onChange={(id, value) => setPhone(value)}
              disabled={isDisabled}
            />
          </div>
        </div>
      )}

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Working Hours</div>
          <div className="small-font">Configure working schedule for this channel</div>
        </div>

        <div className="align-wrapper d-flex align-center">
          <CustomToggle
            id="schedule-enabled"
            label={isScheduleEnabled ? 'Enabled' : 'Disabled'}
            checked={isScheduleEnabled}
            onChange={(id, value) => setIsScheduleEnabled(value)}
            disabled={isDisabled}
          />
        </div>
      </div>

      {isScheduleEnabled && (
        <>
          <WorkScheduler schedule={schedule} setSchedule={setSchedule} isDisabled={isDisabled} />
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Outside Working Hours</div>
              <div className="small-font">Select action outside working hours</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomSelect
                id="outside-working-hours"
                label="Outside Working Hours"
                options={[
                  { value: 'QUEUE', label: 'Queue' },
                  { value: 'MODERATE', label: 'Moderate' },
                  { value: 'DEACTIVATE', label: 'Deactivate' },
                ]}
                value={outsideWorkingHours}
                onChange={(val) => setOutsideWorkingHours(val)}
                multiSelect={false}
                disabled={isDisabled}
              />
            </div>
          </div>
        </>
      )}

      {['IFRAME', 'TELEGRAM'].includes(channelType) && (
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Make Phone field required</div>
            <div className="small-font">Enable or disable Phone field to be required</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <CustomToggle
              id="phone-field-required"
              label={phoneMandatory ? 'Enabled' : 'Disabled'}
              checked={phoneMandatory}
              onChange={(id, value) => setPhoneMandatory(value)}
              disabled={!isPhoneField || isDisabled}
            />
          </div>
        </div>
      )}

      {channelType === 'TELEGRAM' && isPhoneField && (
        <>
          <TextBlock
            title="Text request"
            description="Text that asks the user to enter their phone number"
            id="text-request"
            name="text-request"
            value={textFields.text_request}
            onChange={(value) => setTextFields((prev) => ({ ...prev, text_request: value }))}
            isDisabled={isDisabled}
            height="60px"
          />

          <TextBlock
            title="Text success"
            description="Text shown after the phone number is saved"
            id="text-success"
            name="text-success"
            value={textFields.text_success}
            onChange={(value) => setTextFields((prev) => ({ ...prev, text_success: value }))}
            isDisabled={isDisabled}
            height="60px"
          />

          <TextBlock
            title="Text confirm button"
            description="Text on the phone number sharing button"
            id="text-confirm"
            name="text-confirm"
            value={textFields.text_confirm}
            onChange={(value) => setTextFields((prev) => ({ ...prev, text_confirm: value }))}
            isDisabled={isDisabled}
            height="60px"
          />

          <TextBlock
            title="Text cancel button"
            description="Text on the phone number cancel sharing button"
            id="text-cancel"
            name="text-cancel"
            value={textFields.text_cancel}
            onChange={(value) => setTextFields((prev) => ({ ...prev, text_cancel: value }))}
            isDisabled={isDisabled}
            height="60px"
          />

          <TextBlock
            title="Text response on decline"
            description="The text that appears when a user decline"
            id="text-response-on-decline"
            name="text-response-on-decline"
            value={textFields.text_response_on_decline}
            onChange={(value) =>
              setTextFields((prev) => ({ ...prev, text_response_on_decline: value }))
            }
            isDisabled={isDisabled}
            height="60px"
          />
        </>
      )}

      {channelType === 'IFRAME' && chatType !== 'static-box' && (
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Allow folded chat container</div>
            <div className="small-font">Enable or disable folded container chat</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <CustomToggle
              id="is-folded"
              label={isFolded ? 'Enabled' : 'Disabled'}
              checked={isFolded}
              onChange={(id, value) => setIsFolded(value)}
              disabled={isDisabled}
            />
          </div>
        </div>
      )}
      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Activate channel</div>
          <div className="small-font">
            {channelType === 'INSTAGRAM' && isNew
              ? 'Will be available after authorization'
              : 'Set the channel to be active or inactive to enable or disable it'}
          </div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomToggle
            id="chat-active"
            label={isActive ? 'Active' : 'Inactive'}
            checked={isActive}
            onChange={(id, value) => setIsActive(value)}
            disabled={['INSTAGRAM', 'WHATSAPP'].includes(channelType) && isNew}
          />
        </div>
      </div>
    </div>
  );
}

export default ChannelSettings;
